import { render, staticRenderFns } from "./QuotaTab.vue?vue&type=template&id=2169fd56&scoped=true&"
import script from "./QuotaTab.vue?vue&type=script&lang=js&"
export * from "./QuotaTab.vue?vue&type=script&lang=js&"
import style0 from "./QuotaTab.vue?vue&type=style&index=0&id=2169fd56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2169fd56",
  null
  
)

export default component.exports